var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGame5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 132,
  height: 96,
  viewBox: "0 0 132 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#game5_svg__filter0_ddi_4438_2195)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M93.2603 61.3921L67.9403 75.4021L66.0204 76.4621C65.2704 76.8821 64.3304 76.6721 63.7504 76.0221L67.3404 73.2221L85.5404 59.0421C87.0604 57.8521 87.3103 55.5521 86.1003 53.9221L66.7603 27.9021L62.6104 22.3221L69.7803 18.3521C70.6703 17.8621 71.8004 18.2321 72.3204 19.1721L75.8304 25.6021L93.9304 58.7921C94.4004 59.6521 94.1904 60.6921 93.4804 61.2421C93.4104 61.3021 93.3304 61.3521 93.2504 61.3921H93.2603ZM46.1804 68.9821H43.1004L41.2104 71.4521L39.3304 68.9821H36.2304L39.7104 73.2521L36.0104 77.8021H39.0904L41.2104 75.1021L43.3204 77.8021H46.4304L42.7404 73.2521L46.1904 68.9821H46.1804ZM54.1204 70.4321C53.5304 70.1021 52.8504 69.9321 52.0604 69.9321C51.4704 69.9321 50.9404 70.0321 50.4604 70.2321C50.2704 70.3121 50.1004 70.4121 49.9404 70.5221V67.7421H55.2104V65.5321H47.3804V73.1021H49.1204C49.4204 72.7621 49.7604 72.5121 50.1404 72.3521C50.5204 72.1921 50.9304 72.1121 51.3704 72.1121C52.0004 72.1121 52.4904 72.2821 52.8504 72.6121C53.2104 72.9521 53.3904 73.3921 53.3904 73.9521C53.3904 74.5121 53.2004 74.9521 52.8204 75.2621C52.4404 75.5821 51.9204 75.7421 51.2404 75.7421C50.6504 75.7421 50.0704 75.6421 49.5004 75.4521C48.9304 75.2621 48.3904 74.9721 47.8604 74.6021L47.0104 76.6221C47.3204 76.9021 47.7104 77.1421 48.1804 77.3421C48.6504 77.5421 49.1404 77.7021 49.6804 77.8221C50.2104 77.9421 50.7504 77.9921 51.3004 77.9921C52.2604 77.9921 53.0904 77.8221 53.8004 77.4721C54.5004 77.1221 55.0404 76.6421 55.4204 76.0221C55.8004 75.4021 55.9904 74.6821 55.9904 73.8721C55.9904 73.0621 55.8304 72.3921 55.5004 71.8121C55.1704 71.2221 54.7204 70.7721 54.1304 70.4321H54.1204ZM57.8104 67.8821C57.6304 67.7621 57.4304 67.6521 57.2104 67.5521V67.9021C57.3904 67.8621 57.5904 67.8421 57.8104 67.8821ZM66.8404 71.3921L62.8604 74.4921L62.2004 75.0121L61.5404 75.5321L59.8904 76.8121C59.1304 77.4021 58.0604 77.2521 57.4004 76.5221C57.7804 75.7221 57.9804 74.8321 57.9804 73.8821C57.9804 73.0721 57.8504 72.3321 57.6004 71.6421C58.6004 72.0621 59.9504 72.1821 60.3404 72.1921C60.8604 72.1921 61.5504 72.3921 61.5504 72.3921C61.5504 72.3921 61.5504 71.6621 61.6904 71.1421C61.8204 70.6321 62.2104 68.3921 61.6404 67.3421C61.0804 66.2921 59.9004 65.7421 59.0204 66.3421C59.0204 66.3421 58.4004 66.7121 58.3204 67.5021C58.1804 67.0221 58.0704 66.4421 58.0904 65.7721L57.9604 65.5921L57.2304 66.1621V63.5421H47.7504L30.4104 40.2421C29.7704 39.3821 29.9004 38.1721 30.7004 37.5521L55.3104 18.3721C56.1104 17.7521 57.2804 17.9421 57.9204 18.8021L60.0904 21.7121L60.6204 22.4221L61.1504 23.1321L65.0204 28.3421L84.7904 54.9421C85.4304 55.8021 85.3004 57.0121 84.5004 57.6321L66.8404 71.3921ZM53.4504 28.5221C54.0104 29.5721 55.1904 30.1221 56.0704 29.5221C56.0704 29.5221 56.6904 29.1521 56.7704 28.3621C56.9104 28.8421 57.0204 29.4221 57.0004 30.0921L57.1304 30.2721L58.0504 29.5521L58.9704 28.8321L58.8404 28.6521C58.2004 28.4921 57.6804 28.2321 57.2704 27.9621C58.0404 28.1021 58.5504 27.5821 58.5504 27.5821C59.3504 26.8721 59.1504 25.5621 58.3104 24.7321C57.4704 23.8921 55.2704 23.6821 54.7504 23.6721C54.2304 23.6721 53.5404 23.4721 53.5404 23.4721C53.5404 23.4721 53.5404 24.2021 53.4004 24.7221C53.2704 25.2321 52.8804 27.4721 53.4504 28.5221ZM64.5303 56.9221L67.3503 54.7221L66.9403 54.1721C64.9903 53.6721 63.3803 52.8821 62.1203 52.0521C64.4804 52.4621 66.0604 50.8721 66.0604 50.8721C68.5304 48.6821 67.8904 44.6821 65.3204 42.1121C62.7403 39.5421 55.9804 38.8821 54.3904 38.8721C52.7904 38.8621 50.6804 38.2621 50.6804 38.2621C50.6804 38.2621 50.6804 40.5121 50.2604 42.0921C49.8504 43.6721 48.6704 50.5121 50.4004 53.7421C52.1304 56.9721 55.7304 58.6621 58.4504 56.8121C58.4504 56.8121 60.3704 55.6821 60.6104 53.2421C61.0504 54.7021 61.3704 56.5021 61.3204 58.5621L61.7304 59.1121L64.5504 56.9121L64.5303 56.9221ZM101.93 67.4621L89.9004 24.0421C89.6104 23.0121 88.5803 22.3721 87.6003 22.6221L77.4904 25.1821L95.3904 57.9921C95.8204 58.7721 95.9604 59.6821 95.8004 60.5421C95.6404 61.3921 95.1904 62.1421 94.5404 62.6521C94.4004 62.7621 94.2604 62.8521 94.1104 62.9421L68.7104 76.9921C69.1703 77.4121 69.8004 77.6021 70.4203 77.4421L100.66 69.7821C101.64 69.5321 102.21 68.4921 101.92 67.4621H101.93Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "game5_svg__filter0_ddi_4438_2195",
  x: 0.00390625,
  y: -11.9921,
  width: 131.992,
  height: 119.984,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808333 0 0 0 0 0.49443 0 0 0 0 0.0235764 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2195"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2195",
  result: "effect2_dropShadow_4438_2195"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2195",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2195"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "game5_svg__yellow",
  x1: 30.0052,
  y1: 18.0079,
  x2: 82.8429,
  y2: 93.8366,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "game5_svg__gray",
  x1: 30.0052,
  y1: 18.0079,
  x2: 82.8429,
  y2: 93.8366,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgGame5 as ReactComponent };
export default __webpack_public_path__ + "assets/icons/game5.e7677b.svg";